import {
  ADVICE_ABOUT_YOU_STEP,
  ADVICE_PRICE_STEP,
  ADVICE_YOUR_LIFE_SITUATION_STEP,
} from "Components/Features/CheckPrice/Products/Advice";

import { AkaCartAdviceValues } from "Components/Features/CheckPrice/Products/Advice/ProductDetails/FormElements/interfaces";
import { mapAdviceDataToDetailsFormData } from "Components/Features/CheckPrice/Products/Advice/ProductDetails/utils";
import { AdviceProductIntroFormValues } from "Components/Features/CheckPrice/Products/Advice/ProductIntro/interfaces";
import { isAdviceProductOnCart } from "Store/advice/utils";
import { CollectiveAdvice } from "Store/akaAdvice/interfaces/CollectiveAdvice";
import { Cart } from "Store/cart/cartInterfaces";
import { BooleanFormType } from "Store/interfaces/FormTypes";
import { FormState } from "Store/priceCalculation/priceCalculationInterfaces";
import { booleanToFormBoolean } from "Utils/formUtils";
import { isDefined } from "Utils/functions";
import { mapAdviceDataToPriceFormData } from "../ProductPriceAka/utils";

export const mapFromCommerceAdvice = (
  data: Record<string, any>,
  isAdvisor: boolean,
  advice?: CollectiveAdvice,
): FormState => {
  const cart = data as Cart;
  const cartAdvice = cart.advice as unknown as AkaCartAdviceValues; // TODO-AKA-ADVICE make cart use akacartadvicevalues
  if (!isDefined(cartAdvice)) {
    return {};
  }
  if (!isDefined(advice)) {
    throw new Error("Missing updated advice when mapping cart advice to form.");
  }
  const adviceProducts = cart.products.filter((product) =>
    isAdviceProductOnCart(product, cart),
  );

  return {
    [ADVICE_ABOUT_YOU_STEP.id]: mapAdviceDataToIntroFormData(
      cartAdvice.adviceProductValues.isStayingInNorwayForMoreThanFiveYears,
    ),
    [ADVICE_YOUR_LIFE_SITUATION_STEP.id]: mapAdviceDataToDetailsFormData(
      cartAdvice.adviceProductValues,
    ),
    [ADVICE_PRICE_STEP.id]: mapAdviceDataToPriceFormData(
      cartAdvice.finalAkaAdviceData,
      adviceProducts,
      advice,
      isAdvisor,
    ),
  };
};

const mapAdviceDataToIntroFormData = (
  inNorway: boolean | undefined,
): AdviceProductIntroFormValues => {
  if (isDefined(inNorway)) {
    return {
      isScandinavianCitizen: BooleanFormType.FALSE,
      isStayingInNorwayForMoreThanFiveYears: booleanToFormBoolean(inNorway),
      pep: BooleanFormType.FALSE,
    };
  }
  return {
    isScandinavianCitizen: BooleanFormType.TRUE,
    pep: BooleanFormType.FALSE,
  };
};
